import React from 'react';
import {
  NavigationContainer,
  NavigationButton,
  ButtonGroup
} from '../../styles/onboarding/OnboardingNavigation.styles';

interface OnboardingNavigationProps {
  onNext: () => void;
  onBack: () => void;
  onSkip?: () => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  canSkip: boolean;
  isNextDisabled?: boolean;
  nextButtonText?: string;
}

export const OnboardingNavigation: React.FC<OnboardingNavigationProps> = ({
  onNext,
  onBack,
  onSkip,
  isFirstStep,
  isLastStep,
  canSkip,
  isNextDisabled = false,
  nextButtonText
}) => {
  return (
    <NavigationContainer>
      <ButtonGroup>
        {!isFirstStep && (
          <NavigationButton $variant="secondary" onClick={onBack}>
            ← Back
          </NavigationButton>
        )}
      </ButtonGroup>
      <ButtonGroup>
        {canSkip && onSkip && (
          <NavigationButton $variant="skip" onClick={onSkip}>
            Skip
          </NavigationButton>
        )}
        <NavigationButton
          $variant="primary"
          onClick={onNext}
          disabled={isNextDisabled}
        >
          {nextButtonText || (isLastStep ? 'Complete' : 'Next')}
        </NavigationButton>
      </ButtonGroup>
    </NavigationContainer>
  );
};

